// Re-export from shared package
// For standalone use without workspace, you can use the local client below
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://vmudwhkclqbvobvsenaa.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZtdWR3aGtjbHFidm9idnNlbmFhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYyNTQ3MzQsImV4cCI6MjA2MTgzMDczNH0.StmTS7a-z0_TIRzt4Dz1dZXtGE-gxEiTeixBji0JnYU';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
});

export const supabaseUrl = SUPABASE_URL;

// Session-FREE client for public pages (survey/feedback QR landing).
// The main client persists sessions; a stale/expired token in localStorage
// makes PostgREST reject even anon-readable rows, and the public pages then
// wrongly report "not found". Public lookups must always run as anon.
export const publicSupabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
  },
});
